import http from '@/communication/AuthConnection'

export default (eventId) => {
  return http.get(`/v1/event-detail/import-model/${eventId}`, { responseType: 'blob' })
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/event-detail/GenerateImportModel.js